export enum PageContextName {
  farmerStrategy = 'FarmerStrategy',
  dap = 'DAP',
  dapFlowAproval = 'DapFlowApproval',
  dnc = 'DNC',
  directSalesAssistant = 'DirectSalesAssistant',
  pdfVehiclesAvailability = 'PDFVehiclesAvailability',
  directSalesAssistantSearchClient = 'directSalesAssistantSearchClient'
}
